import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Panel from 'components/shared/Panel/index';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams, useLocation } from 'react-router';
import { showToast } from 'utils/helpers';
import { defaultValues, PANEL_TYPES } from './helper/constants';
import { getDetail, update, create } from 'services/recruitment.service';
import RecruitmentTab from './components/add/recruitmentVN/RecruitmentTab';
import RecruitmentEnTab from './components/add/recruitmentEN/RecruitmentEnTab';

const RecruitmentAddPage = () => {
  const methods = useForm({
    defaultValues: {
      is_active: 1,
    },
  });

  const { reset, register, watch } = methods;

  let { recruitment_id } = useParams();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);

  const disabled = useMemo(() => pathname.includes('/detail'), [pathname]);
  const onSubmit = async (payload) => {
    try {
      setLoading(true);
      let label;
      if (recruitment_id) {
        await update(payload);
        label = 'Chỉnh sửa';
      } else {
        const { recruitmentId } = await create(payload);
        label = 'Thêm mới';
        window._$g.rdr('/recruitment/edit/' + recruitmentId);
      }
      showToast.success(`${label} thành công !`);
    } catch (error) {
      showToast.error(error?.message || 'Có lỗi xảy ra!');
    } finally {
      setLoading(false);
    }
  };

  const loadDetail = useCallback(() => {
    if (recruitment_id) {
      setLoading(true);
      getDetail(recruitment_id)
        .then((value) => {
          if (value) reset({ ...value });
        })
        .catch((error) => {
          showToast.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      methods.reset(defaultValues);
    }
  }, [recruitment_id, reset]);

  useEffect(loadDetail, [loadDetail]);

  const panels = [
    {
      key: PANEL_TYPES.RECRUITMENTVN,
      label: 'Thông tin chung',
      noActions: true,
      component: RecruitmentTab,
      disabled: disabled,
      loading: loading,
    },
    {
      key: PANEL_TYPES.RECRUITMENTEN,
      label: 'Tiếng anh',
      component: RecruitmentEnTab,
      disabled: disabled,
      loading: loading,
    },
  ];

  return (
    <FormProvider {...methods}>
      <div className='bw_main_wrapp'>
        <Panel panes={panels} hasSubmit onSubmit={onSubmit} />
      </div>
    </FormProvider>
  );
};

export default RecruitmentAddPage;
